import { useMemo } from 'react';

import FeatureGates from '@atlaskit/feature-gate-js-client';

import { fg } from '@confluence/feature-gating';
import { useIsLivePage } from '@confluence/live-pages-utils/entry-points/useIsLivePage';

export const useEditorFullPageExperiments = () => {
	const isLivePage = useIsLivePage();

	return useMemo(
		() => ({
			'sticky-scrollbar': FeatureGates.getExperimentValue<boolean>(
				'platform_editor_tables_sticky_scrollbar',
				'isEnabled',
				false,
			),
			'table-drag-and-drop': FeatureGates.getExperimentValue<boolean>(
				'platform_editor_tables_drag_and_drop',
				'isEnabled',
				false,
			),
			'table-selector': FeatureGates.getExperimentValue<boolean>(
				'platform_editor_tables_table_selector',
				'isEnabled',
				false,
			),
			'macro-interaction-button-updates': isLivePage
				? true
				: FeatureGates.getExperimentValue<boolean>(
						'confluence_live_macros_config_button_updates',
						'isEnabled',
						false,
					),
			'macro-interaction-updates': isLivePage
				? true
				: FeatureGates.getExperimentValue<boolean>(
						'confluence_frontend_macro_interaction_design',
						'isEnabled',
						false,
					),
			'table-preserve-width': FeatureGates.getExperimentValue<boolean>(
				'platform_editor_table_preserve_width',
				'isEnabled',
				false,
			),
			'table-with-fixed-column-widths-option': FeatureGates.getExperimentValue<boolean>(
				'platform_editor_preserve_table_widths_part_two',
				'isEnabled',
				false,
			),
			'table-duplicate-cell-colouring': FeatureGates.getExperimentValue<boolean>(
				'platform_editor_table_duplicate_cell_colouring',
				'isEnabled',
				false,
			),
			'table-sort-column-reorder': FeatureGates.getExperimentValue<boolean>(
				'platform_editor_table_sort_column_reorder',
				'isEnabled',
				false,
			),
			'element-drag-and-drop': fg('platform_editor_element_drag_and_drop'),
			'table-new-column-resizing': FeatureGates.getExperimentValue<boolean>(
				'platform_editor_table_new_column_resizing',
				'isEnabled',
				false,
			),
			'more-elements-in-quick-insert-view': FeatureGates.getExperimentValue<boolean>(
				'platform_editor_more_elements_in_quick_insert_view',
				'isEnabled',
				false,
			),
			'platform-editor-aa': FeatureGates.getExperimentValue<boolean>(
				'platform_editor_aa',
				'isEnabled',
				false,
			),
			'platform-editor-aa-gate': fg('platform_editor_aa_gate'),
		}),
		[isLivePage],
	);
};
